import { Key } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdmin } from './AdminContext';

export const AdminSettingsTab = () => {
  const { credentialsForm, setCredentialsForm, changingCredentials, handleChangeCredentials } = useAdmin();

  return (
    <div className="max-w-2xl">
      <h2 className="text-xl font-semibold mb-4 flex items-center gap-2"><Key size={20} /> Change Account Credentials</h2>
      <Card className="bg-card border-border">
        <CardHeader>
          <CardTitle>Update Your Login</CardTitle>
          <CardDescription>Change your admin account email and/or password. You must enter your current password to make changes.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleChangeCredentials} className="space-y-4">
            <div className="space-y-2"><Label htmlFor="currentPassword">Current Password *</Label><Input id="currentPassword" type="password" value={credentialsForm.currentPassword} onChange={(e) => setCredentialsForm({...credentialsForm, currentPassword: e.target.value})} placeholder="Enter your current password" required /></div>
            <div className="border-t border-border pt-4 mt-4"><p className="text-sm text-muted-foreground mb-4">Leave fields blank to keep current values</p></div>
            <div className="space-y-2"><Label htmlFor="newEmail">New Email</Label><Input id="newEmail" type="email" value={credentialsForm.newEmail} onChange={(e) => setCredentialsForm({...credentialsForm, newEmail: e.target.value})} placeholder="Enter new email (optional)" /></div>
            <div className="space-y-2"><Label htmlFor="newPassword">New Password</Label><Input id="newPassword" type="password" value={credentialsForm.newPassword} onChange={(e) => setCredentialsForm({...credentialsForm, newPassword: e.target.value})} placeholder="Enter new password (optional)" /></div>
            <div className="space-y-2"><Label htmlFor="confirmPassword">Confirm New Password</Label><Input id="confirmPassword" type="password" value={credentialsForm.confirmPassword} onChange={(e) => setCredentialsForm({...credentialsForm, confirmPassword: e.target.value})} placeholder="Confirm new password" /></div>
            <Button type="submit" disabled={changingCredentials} className="w-full">{changingCredentials ? 'Updating...' : 'Update Credentials'}</Button>
          </form>
        </CardContent>
      </Card>
      <Card className="bg-card border-border mt-6">
        <CardHeader><CardTitle>Current Admin Info</CardTitle></CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground"><strong>Email:</strong> admin@twintube.com<br/><strong>Role:</strong> Administrator<br/><strong>Notifications:</strong> mysterymachinetc@gmail.com</p>
        </CardContent>
      </Card>
    </div>
  );
};
